import { AdjustedLine, ModifierContext } from "../modifier-models";
import { BaseRule } from "../rule-base";

// ===== rules/rule-0013-endoscopy-reduce.ts ==================================
export class Rule0013 extends BaseRule {
    name = '0013 endoscopy at op (50%)';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.isModifier || line.isConsult || !line.modifiers?.includes('0013')) return;

        const newUnits = line.units * 0.5;
        
        if (autoApply) {
            line.adjustedUnits = newUnits;
            line.trace.push('0013 ×0.5');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0013',
                message: '50% reduction for endoscopy at operation',
                kind: 'overwrite',
                unitsDelta: newUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines
            .filter(l => !l.isModifier && !l.isConsult && l.modifiers?.includes('0013'))
            .forEach(l => {
                l.adjustedUnits = l.units * 0.5;
                l.trace.push('0013 ×0.5');
            });
        return lines;
    }
}